import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import AuthService from "../../../../services/auth/AuthService";
import FloorService from "../../../../services/floor/FloorService";
import SensorService from "../../../../services/sensor/SensorService";
import { colorPalette } from "./chartOption";
import { useTranslation } from "react-i18next";

const QuantityPerFloor = () => {
    const [residualMaterialPerFloor, setResidualMaterialPerFloor] = useState<
        Map<string, number>
    >(new Map());
    const { t } = useTranslation(["sensor"]);

    useEffect(() => {
        const fetchResidualMaterialPerFloor = async () => {
            const userCompanyId = AuthService.user?.companyId || 0;
            const startDate = new Date();
            const endDate = new Date();

            return await SensorService.GetResidualMaterialPerFloor(
                userCompanyId,
                startDate,
                endDate
            );
        };

        fetchResidualMaterialPerFloor().then(async (residual) => {
            if (!residual || !residual.size) return;

            const userBuildingId = AuthService.user?.buildingId || 0;
            const fetchedFloors = await FloorService.GetFloors(userBuildingId);
            const newDataTotal: Map<string, number> = new Map();

            fetchedFloors.forEach((floor) => {
                newDataTotal.set(
                    floor.name,
                    residual.get(floor.id.toString()) || 0
                );
            });
            setResidualMaterialPerFloor(newDataTotal);
        });
    }, []);

    if (!residualMaterialPerFloor) return <></>;
    const colors = colorPalette.slice(
        0,
        Array.from(residualMaterialPerFloor.keys()).length
    );

    const chartData = {
        options: {
            chart: {
                id: "quantity",
            },
            xaxis: {
                categories: Array.from(residualMaterialPerFloor.keys()),
            },
            colors: colors,
            dataLabels: {
                enabled: false,
            },
            title: {
                text: 'Quantity per floor'
              },
        },
        series: [
            {
                name: t("sensor.chart.quantity"),
                data: Array.from(residualMaterialPerFloor.values()),
            },
        ],
    };

    return (
        <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={300}
        />
    );
};

export default QuantityPerFloor;
